import { Paper, FormGroup, Button, InputLabel, FormControl, Select, MenuItem, FormControlLabel, TextField, Checkbox} from "@material-ui/core"
import { makeStyles} from '@material-ui/core/styles';
import { useState,  useEffect } from "react";
import { updateAssetdata, fetchDest, updateRulesdata, fetchAsset, leadassignment, newleadassignment} from "../api/customerapi";
import { v4 as uuidv4 } from "uuid";
import GetRole from "./user";
import {preventDoubleClick} from "./preventDC.js"
import {DataGrid} from "@mui/x-data-grid";
import {CSVLink} from "react-csv"


const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
   
    headertext: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(3),
    },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: theme.spacing(14),
        height: theme.spacing(5),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        fontSize: 10
      },
    formgroup: {
        justifyContent: "center",  
        alignContent: "center", 
    }, 
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(40),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
      textField2: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(80),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
  }));

const Listassetdata=()=>{
    const classes = useStyles();
const width = window.innerWidth-200;
    const columns = [
    { field: 'asset_type', 
  headerName: 'Asset', 
  width: width/12,
  cellClassName: "gridcell"
  //align:"center",
  //headerAlign:"center"
},
    { field: 'in_stock', 
    headerName: 'In Stock', 
    width: width/12,
    cellClassName: "gridcell"
    //align:"center",
    //headerAlign:"center"
    },
    {
      field: 'in_use',
      headerName: 'In Use',
      width: width/12,
      
    },
    {
      field: 'waiting',
      headerName: 'Waiting',
      width: width/12,
    },
    {
      field: 'damaged',
      headerName: 'Damaged',
      width: width/12,
    },
    {
      field: 'lost',
      headerName: 'Lost',
      width: width/12,
    },
    {
      field: 'total',
      headerName: 'Total',
      width: width/12,
    },
    
    
  ];
    const [assetData, setassetData] = useState([]);
    const [oldassetData, setoldassetData] = useState([]);
    const [filterData, setfilterData] = useState([]);
    const [emplist, setemplist] = useState([]);
     const [response, setresponse] = useState([]);
      const [assettable, setassettable] = useState([]);
   const { cuser, role, employeelist, destinationlist, loading } = GetRole();

   const headers=[
        {label:"Asset Type", key:"asset_type"},
        {label:"Model", key:"model"},
        {label:"Attribute", key:"attribute"},
        {label:"Purchase Date", key:"purchase_date"},
        {label:"Seller", key:"seller"},
        {label:"Cost", key:"cost"},
        {label:"Identifier", key:"identifier"},
        {label:"Status", key:"status"},
        {label:"Owner", key:"owner"},
       
   ]

    useEffect(() => {
        getEmployees()
        
      }, []);

      const getEmployees = async () => {
        try{
        
       
        const empsplist2 = employeelist.filter((emp) => emp.role !== "Ex-employee");
        //const empsplist = data.data.filter((emp) => emp.role == "Sales" || emp.role == "TL");
    
        var empshortname2 = empsplist2.map((emp) => emp.short_name);
       
        if(empshortname2.length==0){
          empshortname2=["Amit"]
        }
        console.log(empshortname2)
        let sortedemp = empshortname2.sort()
        setemplist(sortedemp)
      }catch(err){
        console.log(err)
      }
      };

      const scrollToPageBottom = () => {
  window.scrollTo({
    top: document.documentElement.scrollHeight,
    behavior: 'smooth',
  });
        };

    function areIdentifiersUnique(arr) {
  const seen = new Set();

  for (const item of arr) {
    if (seen.has(item.identifier)) {
      return false; // duplicate found
    }
    seen.add(item.identifier);
  }

  return true; // all unique
}


      const addasset = () => {
        //console.log(cpdata)
    
        setassetData(
          assetData.length == 0
            ? [{ id: uuidv4() }]
            : [...assetData, { id: uuidv4() }]
        );
      };
    
      const removeasset = () => {
       const N = window.prompt("Enter index of asset to be deleted:") // We want to remove the 3rd element
        const indexToDelete = N - 1; // Index 2 (Mango)

if (indexToDelete > -1 && indexToDelete < assetData.length) {
    
    setassetData(assetData.filter((_, index) => index !== indexToDelete));
}
        
      };

      function buildAssetStatusMatrix(data) {
  const result = {};
  const allStatuses = new Set();

  data.forEach(({ asset_type, status }) => {
    allStatuses.add(status);

    if (!result[asset_type]) {
      result[asset_type] = {};
    }

    result[asset_type][status] =
      (result[asset_type][status] || 0) + 1;
  });

  return {
    matrix: result,
    statuses: Array.from(allStatuses)
  };
}

       const getAsset = async () => {
              try{
              const data = await fetchAsset();
              console.log(data.data)
              setresponse(data.data[0])
              setassetData(data.data[0].assetlist);
              setoldassetData(data.data[0].assetlist);
            const { matrix, statuses } = buildAssetStatusMatrix(data.data[0].assetlist);
            //console.log(matrix);
            //console.log(statuses);
            const tableRows = Object.keys(matrix).map(assetType => {
            const row = { assetType };

                statuses.forEach(status => {
                    row[status] = matrix[assetType][status] || 0;
                });

                return row;
            });

            console.log(tableRows);
            setassettable(tableRows)
            }catch(err){
              console.log(err)
            }
            };
    
            useEffect(() => {
                if(!loading){
                    getEmployees()
                   
                    getAsset()
                }
                  }, [loading, cuser, role, employeelist, destinationlist]);


    const updateasset=async()=>{
        console.log(assetData)
        if(assetData.length-oldassetData.length>5 || oldassetData.length-assetData.length>5){
          alert("Significant change in asset numbers. echeck")
        }else{
        const isUnique = areIdentifiersUnique(assetData);
        if(isUnique){
        try{
        const assetupdate=await updateAssetdata(response._id, assetData)
        if (
          assetupdate.status == 200 ||
          201 ||
          202 ||
          203 ||
          204 ||
          205 ||
          206 ||
          207
        ) {
          alert(
            "Asset data updated"
          );
          window.location = ("/listassetdata");
        } else {
          alert("Something went wrong. Contact support");
          window.location = "/";
        }
   
      }catch(err){
        console.log(err)
      }
    
       }else{
        alert("Unqiue identifier not found");
    }
  }
    }

     const assetdisplay=assettable.map(a=>({
        asset_type: a.assetType, 
    id:assettable.indexOf(a),
    in_use:a["In Use"],
    in_stock:a["In Stock"],
    waiting:a["Waiting to be repaired"],
    damaged:a["Damaged"],
    lost:a["Lost"],
    total:(a["In Use"]||0)+(a["In Stock"]||0)+(a["Waiting to be repaired"]||0)+(a["Damaged"]||0)+(a["Lost"]||0),
    
    }));

    
    


    var l1=[...assetData]
    if(filterData.type){
      l1=l1.filter(ass=>ass.asset_type==filterData.type)
      // console.log(temp)
      // setleadrules(temp)
    }
   //.log(leadrules)
    return ( 
      <div>
  
        <Paper variant="outlined" className={classes.paper} elevation={10}> 
         {l1.length>1?(<div>
                   <CSVLink data={l1} headers={headers}>Download CSV</CSVLink>
                   </div>
                ):("")}
        {assetdisplay && assetdisplay.length>0?(
             <div style={{ height: 600, width: '100%' }}>
         <DataGrid rows={assetdisplay} 
                
                columns={columns}
                // pageSize={20}
                autoPageSize
                // autoHeight
                >      
              </DataGrid> 
              </div>
              ):("")}
         <div align="center">
         <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                    <InputLabel id="tl">Asset Type</InputLabel>
                        <Select displayEmpty classname={classes.textField} labelId="tl" InputLabelProps={{ shrink: true }}  onChange={(e)=> setfilterData({...filterData, type:e.target.value})}>
                        <MenuItem value={""}>Clear</MenuItem>
                        <MenuItem value={"Laptop"}>Laptop</MenuItem>
                        <MenuItem value={"Charger Wire"}>Charger Wire</MenuItem>
                        <MenuItem value={"Charger Adapter"}>Charger Adapter</MenuItem>
                        <MenuItem value={"Mouse"}>Mouse</MenuItem>
                        <MenuItem value={"SIM"}>SIM</MenuItem>
                        <MenuItem value={"Keyboard"}>Keyboard</MenuItem>
                        <MenuItem value={"Phone"}>Phone</MenuItem>
                        <MenuItem value={"Wifi"}>Wifi</MenuItem>
                        <MenuItem value={"AC"}>AC</MenuItem>
                        <MenuItem value={"RO"}>RO</MenuItem>
                        <MenuItem value={"Security Camera"}>Security Camera</MenuItem>
                        <MenuItem value={"Others"}>Others</MenuItem>
                        </Select>
                        </FormControl>
                         <Button
              variant="contained"
              color="primary"
              onClick={()=>scrollToPageBottom()}
              className={classes.button}
            >
              To Bottom
            </Button>
         </div>
       {l1 && l1.map(a=>{return(
        <div>
         <FormGroup row className={classes.formgroup}>
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="name">{"Asset Type ("+Number(l1.indexOf(a)+1)+")"}</InputLabel>
              <Select
                InputLabelProps={{ shrink: true }} 
                classname={classes.textField}
                labelId="name"
               
                value={a.asset_type}
                onChange={(e) => setassetData(l1.map(ass=>ass.id==a.id?{...a, asset_type:e.target.value}:ass))}
              >
             <MenuItem value={""}>Clear</MenuItem>
                        <MenuItem value={"Laptop"}>Laptop</MenuItem>
                        <MenuItem value={"Charger Wire"}>Charger Wire</MenuItem>
                        <MenuItem value={"Charger Adapter"}>Charger Adapter</MenuItem>
                        <MenuItem value={"Mouse"}>Mouse</MenuItem>
                        <MenuItem value={"SIM"}>SIM</MenuItem>
                        <MenuItem value={"Keyboard"}>Keyboard</MenuItem>
                        <MenuItem value={"Phone"}>Phone</MenuItem>
                        <MenuItem value={"Wifi"}>Wifi</MenuItem>
                        <MenuItem value={"AC"}>AC</MenuItem>
                        <MenuItem value={"RO"}>RO</MenuItem>
                        <MenuItem value={"Security Camera"}>Security Camera</MenuItem>
                        <MenuItem value={"Others"}>Others</MenuItem>

              </Select>
            </FormControl>  
           <TextField
                variant="standard"
                InputLabelProps={{ shrink: true }} 
                label="Model"
                value={a.model}
                className={classes.textField}
                onChange={(e) => setassetData(l1.map(ass=>ass.id==a.id?{...a, model:e.target.value}:ass))}
              />
              <TextField
                variant="standard"
                InputLabelProps={{ shrink: true }} 
                label="Attribute"
                value={a.attribute}
                className={classes.textField}
                onChange={(e) => setassetData(l1.map(ass=>ass.id==a.id?{...a, attribute:e.target.value}:ass))}
              />
            </FormGroup>
             <FormGroup row className={classes.formgroup}>
              <TextField
                                 variant="standard"
                                 required
                                 label="Date"
                                 type="date"
                                 InputLabelProps={{ shrink: true }}
                                 value={
                                   "purchase_date"in a && a.purchase_date
                                     ? 
                                     a.purchase_date.split("T").slice(0, 1):""
                                 }
                                 className={classes.textField}
                                 onChange={(e) => setassetData(l1.map(ass=>ass.id==a.id?{...a, purchase_date:e.target.value}:ass))}
                                
                               />
                 <TextField
                variant="standard"
                InputLabelProps={{ shrink: true }} 
                label="Seller"
                value={a.seller}
                className={classes.textField}
                onChange={(e) => setassetData(l1.map(ass=>ass.id==a.id?{...a, seller:e.target.value}:ass))}
              />
               <TextField
                variant="standard"
                InputLabelProps={{ shrink: true }} 
                label="Cost"
                value={a.cost}
                className={classes.textField}
                onChange={(e) => setassetData(l1.map(ass=>ass.id==a.id?{...a, cost:e.target.value}:ass))}
              />
             </FormGroup>
             <FormGroup row className={classes.formgroup}>
                  <TextField
                variant="standard"
                InputLabelProps={{ shrink: true }} 
                label="Identifier"
                value={a.identifier}
                className={classes.textField}
                onChange={(e) => setassetData(l1.map(ass=>ass.id==a.id?{...a, identifier:e.target.value.trim()}:ass))}
              />
               <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="name">{"Status"}</InputLabel>
              <Select
                InputLabelProps={{ shrink: true }} 
                classname={classes.textField}
           
               
                value={a.status}
                onChange={(e) => setassetData(l1.map(ass=>ass.id==a.id?{...a, status:e.target.value}:ass))}
              >

                        <MenuItem value={"In Stock"}>In Stock</MenuItem>
                         <MenuItem value={"In Use"}>In Use</MenuItem>
                        <MenuItem value={"Waiting to be repaired"}>Waiting to be repaired</MenuItem>
                        <MenuItem value={"Damaged"}>Damaged</MenuItem>
                        <MenuItem value={"Lost"}>Lost</MenuItem>
              </Select>
            </FormControl> 
              <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="name">{"Owner"}</InputLabel>
              <Select
                InputLabelProps={{ shrink: true }} 
                classname={classes.textField}
           
               
                value={a.owner}
                onChange={(e) => setassetData(l1.map(ass=>ass.id==a.id?{...a, owner:e.target.value}:ass))}
              >
             <MenuItem value={"Company"}>Company</MenuItem>
             {emplist.map(e=>
             <MenuItem value={e}>{e}</MenuItem>
             )}
                       

              </Select>
            </FormControl>
             </FormGroup>
              <FormGroup row className={classes.formgroup}>
                 <TextField
                variant="standard"
                InputLabelProps={{ shrink: true }} 
                label="Notes"
                value={a.notes}
                fullWidth
                className={classes.textField2}
                onChange={(e) => setassetData(l1.map(ass=>ass.id==a.id?{...a, notes:e.target.value.trim()}:ass))}
              />
              </FormGroup>
             <br></br>
            <hr></hr>
            <br></br>
            </div>
            
       )})}
           
            
            <br></br>
            <hr></hr>
            <br></br>
           
            <FormGroup row className={classes.formgroup}>
            <Button
              variant="contained"
              color="primary"
              onClick={()=>updateasset()}
              className={classes.button}
            >
              Save
            </Button>
            <Button
              href={"/home"}
              variant="contained"
              color="secondary"
              className={classes.button}
            >
              Cancel
            </Button>
            {l1.length==assetData.length?(
             <Button
                        onClick={preventDoubleClick(addasset)}
                        color="Primary"
                        variant="contained"
                        className={classes.button}
                      >
                        Add Asset
                      </Button> 
                         ):("")}
            {cuser=="Debayan"?(
                 <Button
                        onClick={preventDoubleClick(removeasset)}
                        color="inherit"
                        variant="contained"
                        className={classes.button}
                      >
                        Delete Asset
                      </Button>
            ):("")}
            
           
                     
            </FormGroup>
        </Paper>
        
        </div>
    )   
}

export default Listassetdata;